<div class="grid">
  <!-- FROM -->
  <div class="col-12 lg:col-6 mt-5">
    <div class="flex align-items-center justify-content-center gap-2">
      <strong>From:</strong>
      <p-floatLabel>
        <p-inputNumber
          id="yearFrom"
          [useGrouping]="false"
          [showButtons]="true"
          [maxFractionDigits]="0"
          [(ngModel)]="anomaliesModel().anomaliesFrom"
          [step]="1"
          [min]="minYear"
          [max]="maxYear">
        </p-inputNumber>
        <label for="yearFrom">Choose year</label>
      </p-floatLabel>

    </div>
  </div>

  <!-- TO -->
  <div class="col-12 lg:col-6 mt-5">
    <div class="flex align-items-center justify-content-center gap-2">
      <strong>To:</strong>
      <p-floatLabel>
        <p-inputNumber
          id="yearTo"
          [useGrouping]="false"
          [showButtons]="true"
          [maxFractionDigits]="0"
          [(ngModel)]="anomaliesModel().anomaliesTo"
          [step]="1"
          [min]="minYear"
          [max]="maxYear">
        </p-inputNumber>
        <label for="yearTo">Choose year</label>
      </p-floatLabel>
    </div>
  </div>
</div>
